<template>
  <div class="dialog-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="overrideReferralState" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="State" prop="status">
            <el-select
              v-model="form.status"
              :clearable="false"
              placeholder="Select Status">
              <el-option
                v-for="item in allReferralStates"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Status Reason" prop="statusReason">
            <el-input v-model="form.statusReason" type="textarea" placeholder="Reason for Status" />
          </el-form-item>
          <el-form-item label="Payout" prop="amount">
            <el-input v-model="form.amount" type="number" placeholder="Amount to Pay for Referral">
              <template slot="prepend"><i class="fa fa-dollar-sign"></i></template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="save">Save</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Required } from '@/util/formValidators';

export default {
  name: 'OverrideReferralStatus',
  props: {
    status: {
      type: Number,
      default: undefined,
    },
    statusReason: {
      type: String,
      default: undefined,
    },
    amount: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        status: undefined,
        statusReason: undefined,
        amount: undefined,
      },
      rules: {
        status: [Required],
        amount: [Required],
      },
    };
  },
  computed: {
    ...mapGetters('Lookup', [
      'allReferralStates',
    ]),
  },
  methods: {
    ...mapActions('Lookup', ['getReferralStates']),
    save() {
      this.$refs.overrideReferralState.validate((valid) => {
        if (valid) {
          this.$emit('save', this.form);
          this.closeDialog();
        }
        return valid;
      });
    },
    closeDialog() {
      this.$emit('close');
    },
  },
  watch: {
    amount(val) {
      this.form.amount = val;
    },
    status(val) {
      this.form.status = val;
    },
    statusReason(val) {
      this.form.statusReason = val;
    },
  },
  mounted() {
    this.getReferralStates();
    this.form.amount = this.amount;
    this.form.status = this.status;
    this.form.statusReason = this.statusReason;
  },
};

</script>
